import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Block } from '@share/models/block';
import { PaginatedResponse } from '@share/models/paginated-response';
import { api } from '@share/config/api.config';
import { environment } from 'src/environments/environment';
import { CreateBlockRequest } from 'src/app/share/requests/create-block-request';
import { UpdateBlockRequest } from 'src/app/share/requests/update-block-request';
import { handleHttpError } from '@share/utils/http-error.utils';
import { BlockYearlySummaryResponse } from '@share/models/block-yearly-summary';
import { ListBlockRequest } from '@share/requests/list-block-request';

@Injectable({
  providedIn: 'root',
})
export class BlockService {

  // Injects
  private readonly httpClient = inject(HttpClient);


  public listBlocks(listBlockRequest: ListBlockRequest): Observable<PaginatedResponse<Block>> {

    const resource = `${environment.acreageApiUrl}/${api.v1.blocks}/list`;

    return this.httpClient.post<PaginatedResponse<Block>>(resource, listBlockRequest).pipe(handleHttpError());
  }


  public getBlockById(id: number): Observable<Block | null> {

    const resource = `${environment.acreageApiUrl}/${api.v1.blocks}/${id}`;

    return this.httpClient.get<Block>(resource).pipe(handleHttpError());
  }


  public getBlockYearlySummary(id: number, year: number): Observable<BlockYearlySummaryResponse> {

    const resource = `${environment.acreageApiUrl}/${api.v1.blocks}/${id}/yearly-summary?year=${year}`;

    return this.httpClient.get<BlockYearlySummaryResponse>(resource).pipe(handleHttpError());
  }


  public createBlock(newBlock: CreateBlockRequest): Observable<Block> {

    const resource = `${environment.acreageApiUrl}/${api.v1.blocks}`;

    return this.httpClient.post<Block>(resource, newBlock).pipe(handleHttpError());
  }


  public updateBlock(updateRequest: UpdateBlockRequest): Observable<Block> {

    const resource = `${environment.acreageApiUrl}/${api.v1.blocks}/${updateRequest.id}`;

    return this.httpClient.put<Block>(resource, updateRequest).pipe(handleHttpError());
  }


  public deleteBlock(id: number): Observable<object> {

    const resource = `${environment.acreageApiUrl}/${api.v1.blocks}/${id}`;

    return this.httpClient.delete(resource).pipe(handleHttpError());
  }


  public canEditTight(): Observable<boolean> {

    const resource = `${environment.acreageApiUrl}/${api.v1.blocks}/permissions/tight`;

    return this.httpClient.get<boolean>(resource).pipe(handleHttpError());
  }


  public canWriteBlock(): Observable<boolean> {

    const resource = `${environment.acreageApiUrl}/${api.v1.blocks}/permissions/can-write`;

    return this.httpClient.get<boolean>(resource).pipe(handleHttpError());
  }

  public canWriteSpecificBlock(id: number): Observable<boolean> {

    const resource = `${environment.acreageApiUrl}/${api.v1.blocks}/${id}/permissions/can-write`;

    return this.httpClient.get<boolean>(resource).pipe(handleHttpError());
  }
}
